$(document).ready(function(){
    $(document).on('click', '.custom_popup_opener', function(event) {
        event.preventDefault();
        const productUrl = $(this).attr('data-pro-url');
        const topNotes = $(this).attr('data-top-notes');
        const middleNotes = $(this).attr('data-middle-notes');
        const baseNotes = $(this).attr('data-base-notes');
        
        $.ajax({
            url: productUrl,
            type: 'GET',
            dataType: 'json',
            success: function(data) {
                const product = data.product || {};
                const product_id = data.product.variants[0].id || '';
                const product_price = data.product.variants[0].price || '';
                const product_compare_price = data.product.variants[0].compare_at_price || '';
                const featuredImage = product.image ? product.image.src : '';
                const title = product.title || 'No title available';
                const options = product.options && product.options[0] ? product.options[0].name : 'No options available';
                const variantTitle = product.variants && product.variants[0] ? product.variants[0].title : 'No variant available';
                const description = product.body_html || 'No description available';
    
                const isSoldOut = $(event.currentTarget).closest('.product-item').hasClass('sold_out_item');
                const atcButtonText = isSoldOut ? 'Sold Out' : 'Add to Cart';
                const atcButtonDisabled = isSoldOut ? 'disabled' : '';
                const checkoutButtonStyle = isSoldOut ? 'display:none;' : '';
                
                const popupHtml = `
                    <div class="quick_view_popup_main qv_active">
                        <div class="popup_inner">
                            <div class="popup-close-btn"><img src="https://cdn.shopify.com/s/files/1/0269/7763/2389/files/new_close.svg" alt="Close"/></div>
                            <div class="image_content_pop_wrp">
                                <div class="image_wrp_main">
                                    <div class="image_right">
                                        <img src="${featuredImage}" alt="${title}" height="" width="" lazyload>
                                    </div>
                                </div>
                                <div class="content_main_wrp">
                                    <div class="content_right_inner">
                                        <h2 class="pro_title">${title}</h2>
                                        <div class="pro-variant">
                                            <label class="option_label">${options}</label>
                                            ${variantTitle}
                                        </div>
                                        <div class="pro-variant price">
                                            <span style="color:#000;">Price :</span> $${product_price}
                                            <s class="compare_price">$${product_compare_price}</s>
                                        </div>
                                        <div class="product_description">
                                            ${description}
                                        </div>
                                        <div class="Notes-qv">
                                            <ul>
                                            <li class="notes-li"><span class="notes-head">Top Notes:</span> <span class="notes-span">${topNotes}</span></li>
                                            <li class="notes-li"><span class="notes-head">Middle Notes:</span> <span class="notes-span">${middleNotes}</span></li>
                                            <li class="notes-li"><span class="notes-head">Base Notes:</span> <span class="notes-span">${baseNotes}</span></li>
                                            </ul>
                                        </div>
                                        <div class="product_below_items">
                                            <div class="meta_text"></div>
                                            <div class="buttons_atc_buy_main">
                                                <div class="add_to_cart Atc_main" data-pro-id="${product_id}" onclick="CamilleRochellePopupATC()" ${atcButtonDisabled}>
                                                    <span class="button_atc">${atcButtonText}</span>
                                                </div>
                                                <div class="add_to_cart checkout_main" data-pro-id="${product_id}" onclick="CamilleRochellePopupCheckOut()" style="${checkoutButtonStyle}">
                                                    <span class="button_atc">Buy it Now</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
                
                if ($('.popup_qv_camille_page').length) {
                    $('.popup_qv_camille_page').html(popupHtml);
                    $('.popup_qv_camille_page').show();
                    $('body').addClass('popup-active');
                } else {
                    console.error('Element .popup_qv_camille_page not found.');
                }
            },
            error: function(xhr, status, error) {
                console.error('There was a problem with the AJAX operation:', error);
            }
        });
    });
    
    $(document).on('click', '.popup-close-btn', function() {
        $('.popup_qv_camille_page').html('');
        $('.popup_qv_camille_page').hide();
        $('body').removeClass('popup-active');
    });

    _theme.executeDefferedStylesheet = function(){
      const styles = document.querySelectorAll('link[data-defer]');
      styles.forEach(style => {
        style.media = 'all';
      });
    }
    _theme.executeDefferedStylesheet();
});

function CamilleRochellePopupATC() {
  setTimeout(function(){
  const var_id = document.querySelector('.quick_view_popup_main .add_to_cart.Atc_main').getAttribute('data-pro-id');
  const varID_nw = parseInt(var_id);
  console.log(varID_nw);
  const quantity = 1;
  _theme.Helpers.addProductToCart(varID_nw, quantity, null, function(resp) {
      _theme.MiniCart.lineItemChangeCallBack(resp, function() {
          _theme.toggleLoading();
          const closePopupButton = document.querySelector('.quick_view_popup_main .popup-close-btn');
          if (closePopupButton) {
              closePopupButton.click();
          }
          const cartIconButton = document.querySelector('.cart-icon.cart-handler-header a.fl-alc');
          if (cartIconButton) {
              cartIconButton.click();
          }
      });
  });
},500)
}

function CamilleRochellePopupCheckOut() {
  const variant_id = document.querySelector('.quick_view_popup_main .add_to_cart.checkout_main').getAttribute('data-pro-id');
  console.log(variant_id);
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
          quantity: 1,
          id: variant_id
      },
      dataType: 'json',
      success: function(data) {
          window.location.href = '/checkout';
      }
  });
}
